import React, { useRef, useState } from 'react';
import { CSVLink } from 'react-csv';
import stylesDefault from '../../constants/stylesDefault';
import LargePaper from '../../components/Layout/LargePaper';
import { useDispatch, useSelector } from 'react-redux';
import { getFeedbacks } from '../../store/feedbacks/actions';
import { getRoles } from '../../store/roles/actions';
import FeedbackTable from '../../components/Feedback/FeedbackTable';
import { ROLE_ADMIN } from '../../constants/roles';
import { getUsers, getUsersForRenter } from '../../store/users/actions';
import FeedbacksApiService from '../../services/api/FeedbacksApiService';
import { Grid } from '@material-ui/core';
import KobooButton from '../../components/Layout/KobooButton';

const FeedbacksPage = () => {
  const dispatch = useDispatch();
  const feedbacks = useSelector(state => state.feedbacks);
  const roles = useSelector(state => state.roles);
  const users = useSelector(state => state.users);
  const [csvData, setCsvData] = useState('');

  const csvLinkEl = useRef();
  if (roles.content === null && !roles.pending && roles.error === null) {
    dispatch(getRoles());
  }

  if (
    roles.content
    && feedbacks.content === null
    && !feedbacks.pending
    && feedbacks.error === null
    && roles.error === null
  ) {
    const role = roles.content[users.authUser.uid];
    dispatch(getFeedbacks(users.authUser.ma, role));
  }

  if (roles.content && !users.content && roles.error === null && !users.pending && !users.error) {
    if (roles.content[users.authUser.uid] < ROLE_ADMIN) {
      dispatch(getUsersForRenter(users.authUser.ma));
    } else {
      dispatch(getUsers());
    }
  }

  const downloadCsv = async () => {
    const content = await FeedbacksApiService.getFeedbacks(users.authUser.ma,
      roles.content[users.authUser.uid],
      'csv',
    );
    setCsvData(content);
    csvLinkEl.current.link.click();
  };

  return (
    <LargePaper>
      <h1 style={stylesDefault.title}>Satisfaction client</h1>
      <Grid
        container
        direction="row-reverse"
        justifyContent="space-between"
        alignItems="center"
      >
        <Grid item>
          <KobooButton type="button" onClick={downloadCsv}>
            Télécharger le CSV
          </KobooButton>
        </Grid>
      </Grid>
      <div style={{ display: 'none' }}>
        <CSVLink
          filename={`feedback-${new Date().getTime()}.csv`}
          data={csvData}
          ref={csvLinkEl}
        >
          -
        </CSVLink>
      </div>
      <FeedbackTable
        feedbacks={feedbacks.content || []}
        users={users.content}
        pending={roles.pending || feedbacks.pending || users.pending}
      />
    </LargePaper>
  );
};

export default FeedbacksPage;



// WEBPACK FOOTER //
// ./src/containers/FeedbacksPage/FeedbacksPage.jsx